<template>
    <d-card class="mt-3 mb-3" sm="12">
        <create-sub-user-modal :roles="roles" :permissions="permissions"/>
        <update-sub-user-modal :roles="roles" :permissions="permissions"/>
        <d-card-header class="pb-0 mb-3">Users</d-card-header>
        <d-card-body class="p-0">
            <v-client-table class="dataTables_wrapper domain-table" :data="users" :columns="columns" :options="clientTableOptions">
                <d-col slot="email" slot-scope="props" size="small">
                    <span>
                        {{ props.row.email }}
                    </span>
                </d-col>
                <d-col slot="firstName" slot-scope="props" size="small">
                    <span>
                        {{ props.row['first_name'] }}
                    </span>
                </d-col>
                <d-col slot="lastName" slot-scope="props" size="small">
                    <span>
                        {{ props.row['last_name'] }}
                    </span>
                </d-col>
                <d-col slot="phone" slot-scope="props" size="small">
                    <span>
                        {{ props.row.phone }}
                    </span>
                </d-col>
                <d-col slot="role" slot-scope="props" size="small">
                        {{ props.row.role.name }}
                </d-col>
                <d-col slot="buttons" class="buttons" slot-scope="props" size="small" v-if="checkPermission(permissionTypes.userWrite)">
                    <button
                        class="btn btn-success"
                        @click="showModal('update-sub-user', { user: props.row})"
                    >
                        <span>
                           <i class='fa fa-pencil'/> Update
                        </span>
                    </button>
                    <confirm-message
                        class="d-inline-block cursor-pointer"
                        :message="`Are you sure, that you want to delete this sub user ?`"
                        :keep-button-text="`Cancel`"
                        @confirm="deleteSubUser(props.row.id)"
                    >
                        <button
                            class="btn btn-danger ml-3 d-flex align-items-center"
                        >
                            <i class='fas fa-trash d-block'></i>
                            <span class="d-sm-none d-lg-block ml-2">
                            Delete
                        </span>
                        </button>
                    </confirm-message>
                </d-col>
            </v-client-table>
        </d-card-body>
        <d-card-footer class="d-flex justify-content-end" v-if="checkPermission(permissionTypes.userWrite)">
            <button @click="showModal('create-sub-user')" class="btn mb-2 mr-1 btn-success"><i class="fas fa-plus"></i>  Add new user</button>
        </d-card-footer>
    </d-card>
</template>

<script>
import { SubUsersService } from '@/main';
import notification from '@/mixins/notification';
import permissions from "../../mixins/permissions";
import ConfirmMessage from '@/components/common/confirmMessage.vue';
import CreateSubUserModal from '@/components/users/CreateSubUserModal.vue';
import UpdateSubUserModal from '@/components/users/UpdateSubUserModal.vue';

export default {
    name: "ListUsers",
    mixins: [notification, permissions],
    components: {
        ConfirmMessage,
        CreateSubUserModal,
        UpdateSubUserModal
    },
    data() {
        return {
            roles: [],
            permissions: [],
            users: [],

            columns: ['email', 'firstName', 'lastName', 'phone', 'role', 'buttons'],
            clientTableOptions: {
                perPage: 25,
                pagination: { show: false },
                childRowTogglerFirst: false,
                recordsPerPage: [25, 50, 100],
                skin: 'transaction-history table dataTable',
                filterable: false,
                texts: {
                    limit: 'Show',
                    count: ''
                },
                columnsDisplay: {
                    status: 'desktop',
                    transaction: 'desktop',
                    connected: 'desktop',
                    configured: 'desktop',
                },
                columnsClasses: {
                    network: 'network-table',
                    transaction: 'network-table',
                    integration: 'network-table',
                    connected: 'network-table',
                    configured: 'network-table',
                },
                headings: {
                    email: 'Email',
                    firstName: 'First name',
                    lastName: 'Last name',
                    phone: 'Phone',
                    role: 'Role',
                    buttons: '',
                },
            },
        }
    },
    computed: {
        getSubUsers() {
            return this.$store.getters.subUsers
        }
    },

    methods: {
        getUsers() {
            this.users = this.getSubUsers
        },

        async getRoles() {
          try {
            this.roles = await SubUsersService.getRoles()
          } catch(e) {
            this.showNotification('warn', 'Oops! we have a problem', 'Cant get roles')
            console.log(e)
          }
        },

        async getPermissions() {
          try {
            this.permissions = await SubUsersService.getPermissions()
          } catch(e) {
            this.showNotification('warn', 'Oops! we have a problem', 'Cant get permissions list')
            console.log(e)
          }
        },

        async deleteSubUser(id) {
            try {
                await SubUsersService.delete(id)
                await this.$store.commit('deleteSubUser', id)
                this.showNotification('success', 'Alert', 'User successfully deleted !')
                this.$router.push('/dashboard')
                this.$router.go()
            } catch(e) {
                console.error(e)
                this.showNotification('error-notification', 'Oops! we have a problem')
            }
        },

        showModal(modalName, params = {}) {
            this.$modal.show(modalName, params);
        },
    },

    mounted() {
        this.getRoles()
        this.getPermissions()
        this.getUsers()
    }
}
</script>

<style scoped>

</style>
